// Mock data for the post-login panel — purely client-side, replaces with real API later.

// Toggle off once Dashboard & Price Manager are ready for non-admin accounts.
export const COMING_SOON_FOR_NON_ADMIN = true;

export const PANEL_MENU = [
  { id: "dashboard", label: "Dashboard", to: "/app/dashboard", icon: "LayoutDashboard" },
  { id: "listing-generator", label: "AI Listing Generator", to: "/app/listing-generator", icon: "Wand2" },
  { id: "subscription", label: "Subscription", to: "/app/subscription", icon: "CreditCard" },
  { id: "users", label: "Users", to: "/app/users", icon: "Users" },
  { id: "price-manager", label: "Price Manager", to: "/app/price-manager", icon: "BadgeIndianRupee" },
  { id: "price-reducer", label: "Price Reducer", to: "/app/price-reducer", icon: "PackageCheck" },
  { id: "products", label: "Products", to: "/app/products", icon: "ShoppingBag" },
  { id: "label-desk", label: "LabelDesk", to: "/app/label-desk", icon: "Truck" },
  { id: "profile", label: "Profile", to: "/app/profile", icon: "UserCircle2" },
];

export const MOCK_DASHBOARD = {
  date: new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }),
  metrics: [
    { id: "orders", label: "Today's Orders", value: 47, delta: "+12%" },
    { id: "revenue", label: "Revenue", value: 38200, prefix: "₹", delta: "+18%" },
    { id: "cod", label: "COD Orders", value: 29, delta: "+6%" },
    { id: "prepaid", label: "Prepaid", value: 18, delta: "+9%" },
    { id: "cancelled", label: "Cancelled", value: 3, delta: "-1%" },
    { id: "returns", label: "Returns / RTO", value: 2, delta: "-2%" },
  ],
  splits: [
    { platform: "Meesho", orders: 28, color: "bg-purple-500", pct: 60 },
    { platform: "Flipkart", orders: 19, color: "bg-amber-500", pct: 40 },
  ],
  activity: [
    { id: 1, label: "Order #2143 · Meesho COD", amount: "₹420", when: "2 min ago" },
    { id: 2, label: "Order #2144 · Flipkart Prepaid", amount: "₹1,290", when: "8 min ago" },
    { id: 3, label: "Order #2145 · Meesho COD", amount: "₹650", when: "14 min ago" },
    { id: 4, label: "Listing cloned — Cotton Kurti", amount: "+1", when: "22 min ago" },
    { id: 5, label: "AI listing generated — Saree", amount: "+1", when: "31 min ago" },
    { id: 6, label: "Shipping reduced on SKU MS-2241", amount: "-₹28", when: "44 min ago" },
  ],
};

